export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/48c3d350a874654b9919fc00f7ab5f35.png";